import { Injectable } from '@angular/core';
import { CoinTxn } from '@mommy/models/vender.model';
import { VenderService } from '@mommy/services/vender/vender.service';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { GetCoinBalance, GetCoinTxn } from './vender-user.actions';

export interface VenderUserStateModel {
  current_balance: number;

  memberCoinTxnList: CoinTxn[]; // 會員點數交易紀錄
}

const defaultVenderUserState = (): VenderUserStateModel => {
  return {
    current_balance: 0,
    memberCoinTxnList: [],
  };
};

@State<VenderUserStateModel>({
  name: 'VenderUserState',
  defaults: defaultVenderUserState(),
})
@Injectable()
export class VenderUserState {
  constructor(private venderService: VenderService) {}

  @Selector()
  static current_balance(state: VenderUserStateModel) {
    return state.current_balance;
  }

  @Selector()
  static memberCoinTxnList(state: VenderUserStateModel) {
    console.log('state.memberCoinTxnList', state.memberCoinTxnList);
    return state.memberCoinTxnList;
  }

  // // 會員點數交易紀錄
  // @Selector([VenderUserState._memberCoinTxnList])
  // static memberCoinTxnList(memberCoinTxnList: CoinTxn[]) {
  //   console.log('memberCoinTxnList', memberCoinTxnList);

  //   return memberCoinTxnList;
  //   // return _.chain(memberCoinTxnList)
  //   //   .map((txn) => {
  //   //     const new_txn = _.cloneDeep(txn);
  //   //     // new_txn.txn_dt = format(parse(txn.txn_dt), 'yyyy-MM-dd HH:mm:ss');
  //   //     return new_txn;
  //   //   })
  //   //   .value();
  // }

  // ===============================================================================
  //                             Action
  // ===============================================================================

  // 取得會員點數資訊(balance)
  @Action(GetCoinBalance)
  async GetCoinBalance(ctx: StateContext<VenderUserStateModel>) {
    console.log('[Action] GetCoinBalance');

    try {
      const result = await this.venderService.get_balance();
      console.log('result', result);

      ctx.patchState({
        current_balance: result?.data?.current_balance,
      });
    } catch (error) {
      console.error('GetCoinBalance error', error);
      throw error;
    }
  }

  // 取得會員點數交易紀錄list (線上)
  @Action(GetCoinTxn)
  async GetCoinTxn(ctx: StateContext<VenderUserStateModel>) {
    console.log('[Action] GetCoinTxn');

    try {
      const result = await this.venderService.get_coin_txn_log();
      console.log('result', result);

      ctx.patchState({
        memberCoinTxnList: result?.data,
      });
    } catch (error) {
      console.error('GetCoinTxn error', error);
      throw error;
    }
  }
}
